import Vue from "vue";
Vue.mixin({
  methods: {
    pad(value) {
      return ("000000000" + value).substr(-2);
    },
    dateGenerate(days) {
      let d = new Date(Date.now());
      d.setDate(d.getDate() + days);
      let date = d.getFullYear() + "-";
      date += this.pad(d.getMonth() + 1) + "-";
      date += this.pad(d.getDate());
      return date;
    },
    currency(value, digitsAfterPoint) {
      var formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: digitsAfterPoint,
        maximumFractionDigits: digitsAfterPoint /* this might not be necessary */
      });
      return formatter.format(value);
    },
    newGuid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    }
  }
});
/*import moment from 'moment';
Vue.filter("date", function(value, format){
  if(value) return '';
  if(format) {console.error("Argument format required in filter");return '';}
  return moment(value).format(format);
})*/


// WEBPACK FOOTER //
// ./src/mixins.js